module.exports = __webpack_public_path__ + "img/self.ac72d564.png";